import { AddClientButton } from "components/clients/add-client-button/add-client-button";
import { PageHeader } from "components/layout";
import * as React from "react";
import { PipelineState, usePipelineState } from "store/selectors/hooks";
import { ClientSearch } from "../clients/client-search/client-search";
import { PipelineInner } from "./pipeline-inner";

export const PipelineV2: React.FunctionComponent = () => {
    const pipelineState: PipelineState = usePipelineState();

    return (
        <div className="flex flex-col md:inset-0 md:absolute">
            <PageHeader title="Client Pipeline">
                <AddClientButton />
            </PageHeader>
            <div className="px-4 py-2">
                <ClientSearch includeCardSort />
            </div>
            <div className="pipeline-wrapper bg-brand-700 flex px-4 py-2 flex-1 h-screen md:h-auto md:overflow-hidden">
                {pipelineState && pipelineState.isReady ? (
                    <PipelineInner searchCriteria={pipelineState.searchCriteria} />
                ) : null}
            </div>
        </div>
    );
};
